(function () {
  "use strict";

  var map;
  var bounds;
  var caixa;
  var markers = {};
  let locais = [];

  const iconeMc = url_base + "app/assets/dist/img/maps/marker.png";
  const iconeMcHover = url_base + "app/assets/dist/img/maps/marker_hover.png";
  const clusterImg = url_base + "app/assets/dist/img/maps/m";

  // Obtém os locais e suas coordenadas
  function getLocais() {
    $(".dica-dest").each(function () {
      if ($(this).data("lat") != "" && $(this).data("lng") != "") {
        locais.push({
          id: $(this).data("id"),
          lat: Number($(this).data("lat")),
          lng: Number($(this).data("lng")),
          titulo: $(this).data("titulo"),
          telefone: $(this).data("telefone"),
          imagem: $(this).data("imagem"),
          link: $(this).data("link"),
        });
      }
    });
  }

  // Popula os locais no mapa
  function populaLocais() {
    getLocais();
    if (locais.length > 0) {
      bounds = new google.maps.LatLngBounds();
      locais.forEach(function (local) {
        var position = {
          lat: local.lat,
          lng: local.lng,
        };
        bounds.extend(position);
        var marker = new google.maps.Marker({
          map: map,
          animation: google.maps.Animation.DROP,
          position: position,
          icon: { url: iconeMc, scaledSize: new google.maps.Size(35, 35) },
        });
        marker.addListener("click", function () {
          caixa.setContent(`
            <div class="map-popup">
              <a href="${local.link}" target="_blank"><figure><img src="${local.imagem}"></figure></a>
              <div class="map-popup-titulo">${local.titulo}</div>
              <a href="tel: ${local.telefone}" class="map-popup-telefone"><i class="fas fa-phone fa-flip-horizontal"></i> ${local.telefone}</a>
            </div>`);
          caixa.open(map, marker);
        });
        markers[local.id] = marker;
      });
      if (locais.length > 1) {
        map.fitBounds(bounds);
      } else {
        map.setCenter(bounds.getCenter());
        map.setZoom(15);
      }
      var markerCluster = new MarkerClusterer(map, markers, {
        imagePath: clusterImg,
      });

      $(".dica-dest")
        .on("mouseover", function () {
          markers[$(this).data("id")].setIcon({
            url: iconeMcHover,
            scaledSize: new google.maps.Size(35, 35),
          });
        })
        .on("mouseout", function () {
          markers[$(this).data("id")].setIcon({
            url: iconeMc,
            scaledSize: new google.maps.Size(35, 35),
          });
        });
    }
  }

  // Inicializa o mapa da tela
  function initMap() {
    map = new google.maps.Map(document.getElementById("mapa-locais"), {
      /* mapTypeControl: false,
      streetViewControl: false, */
    });
    caixa = new google.maps.InfoWindow();
    google.maps.event.addListener(map, "click", function () {
      caixa.close();
    });
    populaLocais();
  }

  $(window).load(function () {
    if ($("#mapa-locais").length > 0) {
      initMap();
    }
  });
})();
